var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H2.8a.8.8 0 00-.8.8v9.4a.8.8 0 00.8.8h9.4a.8.8 0 00.8-.8V8",
    stroke: "#A8AAAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.985 2.007h.5a.5.5 0 00-.5-.5v.5zm-6.01 6.718l6.01-6.01-.707-.708-6.01 6.01.707.708zm1.768-6.218h4.242v-1H9.743v1zm3.742-.5V6.25h1V2.007h-1z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/exit.720f0f4d.svg";
export { SvgExit as ReactComponent };